import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useCollection } from '../../hooks/useFirestore';
import { FAQ as FAQType } from '../../types';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const FAQ: React.FC = () => {
  const { t } = useLanguage();
  const { data: allFaqs, loading } = useCollection<FAQType>('faq');
  const faqs = allFaqs.filter(f => f.status !== 'archived');

  return (
    <section id="faq" className="sw-section" role="region" aria-labelledby="faq-title">
      <div className="sw-container">
        <div className="section-header text-center">
          <span className="sw-eyebrow">{t('faq_eyebrow')}</span>
          <h2 id="faq-title">{t('faq_title')}</h2>
          <p className="section-desc">{t('services_desc')}</p>
        </div>
        <div className="faq-container max-w-3xl mx-auto" aria-busy={loading}>
          {loading ? (
            <div className="text-center" aria-live="polite">{t('loading') || 'Loading...'}</div>
          ) : (
            faqs.map((faq, i) => (
              <motion.div
                key={faq.id}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
              >
                <details className="faq-item group">
                  <summary className="flex justify-between items-center gap-4">
                    <span className="font-bold">{faq.question}</span>
                    <ChevronDown className="w-5 h-5 flex-shrink-0 transition-transform duration-300 group-open:rotate-180" style={{ color: 'var(--text-muted)' }} />
                  </summary>
                  <div className="faq-answer">
                    {faq.answer}
                  </div>
                </details>
              </motion.div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
